import { Component, OnInit, AfterViewInit ,ElementRef, ViewChild } from '@angular/core';
import { ROUTES } from '../sidebar/sidebar.component';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { Router } from '@angular/router';
import { UserService } from 'app/services/user/user.service';
import { SharedService } from 'app/services/Shared/Shared.service';
import { AuthService } from 'app/services/auth/auth.service.service';
import { Renderer2 } from '@angular/core';
@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {
  private listTitles: any[];
  location: Location;
  mobile_menu_visible: any = 0;
  private toggleButton: any;
  private sidebarVisible: boolean;

  public userID = "";
  public NotificationReq = {
    UserID : this.sharedService.getUserDetail('Userid'),
    NotificationDate : this.sharedService.getUserDetail('NotificationDate'),
    Type : null,
    RoleId : this.sharedService.getUserDetail('RoleId') 
  }
  public notificationResult:any = []

  public SaveButton = false;
  public UserResponse;
  public userArray: any;
  constructor(private userService: UserService,
    private sharedService: SharedService,
    private authService: AuthService,
    private renderer: Renderer2,
    location: Location, private element: ElementRef, private router: Router) {
    this.location = location;
    this.sidebarVisible = false;
  }

  public NotificationCount = 0;

  @ViewChild('ErrorMessageDiv') errorMessageDiv: ElementRef;
  @ViewChild('ErrorMessageValue') errorMessageValue: ElementRef;
  @ViewChild('closebutton') closebutton;

  public accountmodel = {
    ID: '',
    FirstName: '',
    LastName: '',
    //Password: '',
    EmailAddress: '',
    IsEmailAlert: false,
    //CreatedBy: this.sharedService.getUserDetail('Userid'),
    ModifiedBy: null
  }
  public loginCompanyId = this.sharedService.getUserDetail('CompanyId');

  ngAfterViewInit(){
    console.log("after view init")
  }

  ngOnInit() {    
    this.listTitles = ROUTES.filter(listTitle => listTitle);
    const navbar: HTMLElement = this.element.nativeElement;
    this.toggleButton = navbar.getElementsByClassName('navbar-toggler')[0];
    this.router.events.subscribe((event) => {
      this.sidebarClose();
      var $layer: any = document.getElementsByClassName('close-layer')[0];
      if ($layer) {
        $layer.remove();
        this.mobile_menu_visible = 0;
      }
    });
   
    this.NotificationReq.NotificationDate = this.sharedService.getUserDetail('NotificationDate')
    sessionStorage.setItem('NotificationDate',"")
    this.userService.GetUserNotification(this.NotificationReq).subscribe(result => {
            if(result){
// console.log(result)
          var NotificationData:any = result
          this.NotificationCount = 0;
          var isNewsComment = false;
          var isBriefRequest = true;
          if(NotificationData.length > 0)
          {
            for (var i = 0; i < NotificationData.length; i++) {
              this.NotificationCount += NotificationData[i].NotificationCount; 
              if(NotificationData[i].Type == "NewsComment" && !isNewsComment)    
              {
                isNewsComment = true;
              }
              if(NotificationData[i].Type == "BriefRequest" && !isBriefRequest)    
              {
                isBriefRequest = true;
              }      
            }
            if(isNewsComment){
              this.notificationResult.push({
                type : "NewsComment",
                message : "Check out News comment section, users waiting for your reply.",           
              });
            }
            if(isBriefRequest){
              this.notificationResult.push({
                type : "BriefRequest",
                message : "Check out Brief section, new request(s) received.",           
              });
            }
          }
      }    
    }, error => {
      console.log(error)
    })
  }



  sidebarOpen() {
    const toggleButton = this.toggleButton;
    const body = document.getElementsByTagName('body')[0];
    setTimeout(function () {
      toggleButton.classList.add('toggled');
    }, 500);

    body.classList.add('nav-open');

    this.sidebarVisible = true;
  };
  sidebarClose() {
    const body = document.getElementsByTagName('body')[0];
    this.toggleButton.classList.remove('toggled');
    this.sidebarVisible = false;
    body.classList.remove('nav-open');
  };
  sidebarToggle() {
    // const toggleButton = this.toggleButton;
    // const body = document.getElementsByTagName('body')[0];
    var $toggle = document.getElementsByClassName('navbar-toggler')[0];

    if (this.sidebarVisible === false) {
      this.sidebarOpen();
    } else {
      this.sidebarClose();
    }
    const body = document.getElementsByTagName('body')[0];

    if (this.mobile_menu_visible == 1) {
      // $('html').removeClass('nav-open');
      body.classList.remove('nav-open');
      if ($layer) {
        $layer.remove();
      }
      setTimeout(function () {
        $toggle.classList.remove('toggled');
      }, 400);

      this.mobile_menu_visible = 0;
    } else {
      setTimeout(function () {
        $toggle.classList.add('toggled');
      }, 430);

      var $layer = document.createElement('div');
      $layer.setAttribute('class', 'close-layer');


      if (body.querySelectorAll('.main-panel')) {
        document.getElementsByClassName('main-panel')[0].appendChild($layer);
      } else if (body.classList.contains('off-canvas-sidebar')) {
        document.getElementsByClassName('wrapper-full-page')[0].appendChild($layer);
      }

      setTimeout(function () {
        $layer.classList.add('visible');
      }, 100);

      $layer.onclick = function () { //asign a function
        body.classList.remove('nav-open');
        this.mobile_menu_visible = 0;
        $layer.classList.remove('visible');
        setTimeout(function () {
          $layer.remove();
          $toggle.classList.remove('toggled');
        }, 400);
      }.bind(this);

      body.classList.add('nav-open');
      this.mobile_menu_visible = 1;

    }
  };

  getTitle() {
    var titlee = this.location.prepareExternalUrl(this.location.path());
    if (titlee.charAt(0) === '#') {
      titlee = titlee.slice(1);
    }

    for (var item = 0; item < this.listTitles.length; item++) {
      if (this.listTitles[item].path === titlee) {
        return this.listTitles[item].title;
      }
    }
    return 'Dashboard';
  }

  signout() {
    if(this.sharedService.getUserDetail('Userid') != undefined && this.sharedService.getUserDetail('Userid') != ""){
      var LogOutData = {
        UserID : this.sharedService.getUserDetail('Userid')
      }
      // console.log(LogOutData)

      this.authService.SignOut(LogOutData).subscribe(result => {        
      })
    }
    this.router.navigate(['./']);
  }
  ClosePopUp() {
    // this.accountmodel = this.accountmodels;
    this.errorMessageDiv.nativeElement.style.display = 'none';
  }
  
  AccountDetailsSave() {
    this.SaveButton = true;
    this.userService.UpdateUser(this.accountmodel).subscribe(result => {
      // console.log(result)
      if (result) {
        this.errorMessageDiv.nativeElement.style.display = 'block';
        this.errorMessageDiv.nativeElement.classList.remove('alert-danger');
        this.errorMessageDiv.nativeElement.classList.add('alert-success');
        this.renderer.setProperty(this.errorMessageValue.nativeElement, 'innerHTML', 'Details updated successfully !!');

        setTimeout(() => {
          this.errorMessageDiv.nativeElement.style.display = 'none';
          this.closebutton.nativeElement.click();
          this.SaveButton = false;
          this.router.navigate(['../admin/user/user-listing']);
        }, 2000);

      }
    }, error => {
      this.SaveButton = false;
      this.UserResponse = error;
      this.errorMessageDiv.nativeElement.style.display = 'block';
      this.errorMessageDiv.nativeElement.classList.remove('alert-success');
      this.errorMessageDiv.nativeElement.classList.add('alert-danger');
      this.renderer.setProperty(this.errorMessageValue.nativeElement, 'innerHTML', this.UserResponse.reason);
      console.log(error)
    })
  }

  GetData(){
    this.userID = this.sharedService.getUserDetail('Userid');
    this.userService.GetUserDetails(this.userID).subscribe(result => {
      this.userArray = result;
      this.accountmodel.ID = this.userID;
      this.accountmodel.FirstName = this.userArray[0].FirstName;
      this.accountmodel.LastName = this.userArray[0].LastName;
      this.accountmodel.EmailAddress = this.userArray[0].EmailAddress;
      //this.accountmodel.Password = this.userArray[0].Password;
      this.accountmodel.IsEmailAlert = this.userArray[0].IsEmailAlert;
      this.accountmodel.ModifiedBy = this.userID;
    }, error => {
      console.log(error)
    })
  }

  UpdateNotification (type)
  { 
    this.NotificationCount = 0;
    if(type == "NewsComment")
    {
      this.router.navigate(['../admin/newscomment/newscomment-listing']);
      this.NotificationReq.Type = "NewsComment";
      this.userService.UpdateUserNotification(this.NotificationReq).subscribe();      
    }
    if(type == "BriefRequest")
    {
      this.router.navigate(['../admin/brief/brief-listing']);
      this.NotificationReq.Type = "BriefRequest";
      this.userService.UpdateUserNotification(this.NotificationReq).subscribe();      
    }
    
  }



}

